import EventsList from '@/pages/events/EventsList';
import EventRegister from '../pages/events/eventRegister';
import EventWinnerPick from '@/pages/events/EventWinnerPick';
import EventModify from '../pages/events/eventModify';
import EventStampList from '@/pages/event/stamp/List.vue';
import EventStampRegister from '@/pages/event/stamp/_id/register/_id.vue';
import EventStampSubmit from '@/pages/event/stamp/_id/Submit.vue';
import EventStampWinner from '@/pages/event/stamp/_id/Winner.vue';
import EventStampModify from '@/pages/event/stamp/_id/Modify.vue';
import OldEventsList from '@/pages/event/OldEventsList';

export default {
	EventsList: {
		id: 'EventsList',
		title: '이벤트 리스트',
		heading: '이벤트 리스트',
		path: '/events/list',
		component: EventsList,
	},
	eventRegister: {
		id: 'eventRegister',
		title: '신규 이벤트 등록',
		heading: '신규 이벤트 등록',
		path: '/events/registers',
		component: EventRegister,
	},
	EventWinnerPick: {
		id: 'EventWinnerPick',
		title: '당첨자 선정',
		hasHeaderTitle: true,
		heading: '이벤트 당첨자 선정',
		path: '/events/:idEvent/winner-pick',
		component: EventWinnerPick,
	},
	EventModify: {
		id: 'EventModify',
		title: '이벤트 조회/수정',
		heading: '이벤트 조회/수정',
		path: '/events/modifies/:idEvent',
		component: EventModify,
	},
	EventStampList: {
		component: EventStampList,
		id: 'EventStampList',
		path: '/event/stamp/list',
		title: '출석체크 이벤트 리스트',
		heading: '출석체크 이벤트 리스트',
	},
	EventStampSubmit: {
		component: EventStampSubmit,
		id: 'EventStampSubmit',
		path: '/event/stamp/:idStamp/submit',
		title: '출석체크 이벤트 등록',
		heading: '출석체크 이벤트 등록',
	},
	EventStampWinner: {
		component: EventStampWinner,
		id: 'EventStampWinner',
		path: '/event/stamp/:idStamp/winner',
		title: '출석체크 당첨자 선정',
		heading: '출석체크 당첨자 선정',
	},
	EventStampRegister: {
		component: EventStampRegister,
		id: 'EventStampRegister',
		path: '/event/stamp/:idStamp/register/:idRegister',
		title: '출석체크 참여회원 상세',
		heading: '출석체크 참여회원 상세',
	},
	EventStampModify: {
		component: EventStampModify,
		id: 'EventStampModify',
		path: '/event/stamp/:idStamp',
		title: '출석체크 이벤트 수정',
		heading: '출석체크 이벤트 수정',
	},
	OldEventsList: {
		component: OldEventsList,
		id: 'OldEventsList',
		path: '/events/old-events',
		title: '(구) 이벤트 리스트',
		heading: '(구) 이벤트 리스트',
	},
};
